import getUserLocation from '../utils/location'
import { useCallback } from 'react'

const useUserLocation = (map) => {
  const handleUserLocationClick = useCallback(() => {
    getUserLocation()
      .then((location) => {
        if (location) {
          const { longitude, latitude } = location.coords

          map.current.flyTo({
            center: [longitude, latitude],
            zoom: 12,
            essential: true
          })
        }
      })
      .catch((error) => {
        console.log('Error getting user location:', error)
      })
  }, [map])

  return handleUserLocationClick
}

export default useUserLocation
